import React, { forwardRef, InputHTMLAttributes } from 'react';
import Input from '../Input';
import Label from '../Label';
import FormGroup from '../FormGroup';

export interface DateInputFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  id: string;
  type: 'month' | 'day' | 'year';
  label: string;
  maxLength: number;
  value?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

/**
 * The DateInputField to support DateInput based on [The USWDS Date input component](https://designsystem.digital.gov/components/form-controls/#date-input)
 */
const DateInputField = forwardRef<HTMLInputElement, DateInputFieldProps>(
  (
    {
      id,
      type,
      label,
      maxLength,
      value,
      className,
      disabled,
      onChange,
      onBlur,
      onFocus,
      'aria-describedby': ariaDescribedBy,
    }: DateInputFieldProps,
    ref,
  ): JSX.Element => {
    return (
      <FormGroup className={`usa-form-group--${type}`}>
        <Label htmlFor={id}>{label}</Label>
        <Input
          id={id}
          ref={ref}
          name={type}
          aria-describedby={ariaDescribedBy}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
          value={value}
          className={className}
          disabled={disabled}
        />
      </FormGroup>
    );
  },
);

export default DateInputField;
